import { logError } from "@ctsu/loader";
import { isEmpty, isNil } from "lodash";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import indexRoutes from "routes/appRoutes";

let flatRoutes = [];
indexRoutes.forEach((route) => {
  flatRoutes.push(route);
  if (route.subRoutes) {
    flatRoutes = [...flatRoutes, ...route.subRoutes];
  }
});

  /**
   * @see {@link https://confluence.ctsu.org/display/REG/Application+Tab+Naming | confluence}
   * @param {*} location
   * @returns
   */
const DocTitle = () => {
  const location = useLocation();
  const getScreenVals = (search) => {
    let screenValues = null;
    // check if query params exists
    try {
      if (search) {
        const searchParams = search.substring(3);
        const decodedParams = atob(searchParams);
        const query = new URLSearchParams(decodedParams);
        const instId = query.get("instId");
        const protNum = query.get("protNum");
        screenValues = instId ? `${instId}, ${protNum}` : "";
      }
    } catch (e) {
      logError(e, "Failed to decode query params. DocTitle.js");
    }
    return screenValues;
  };

  const getTitleInfo = useCallback((screenValues, currentRoute, titleVal) => {
    const prefix = `${currentRoute.parentPathName || ""}`;
    const dynamicValues = screenValues ? `- ${screenValues} ` : "";
    const tabTitle = currentRoute.browserTabTitle
      ? `${currentRoute.browserTabTitle} `
      : "";
    const title = `${prefix}${tabTitle}${dynamicValues} ${
      prefix || tabTitle || dynamicValues ? "|" : ""
    } ${titleVal}`.trim();
    return title;
  }, []);

  const getTitle = useCallback(() => {
    let title = "Regulatory"; // Application name
    if (location != null) {
      const currentRoute = flatRoutes.find((f) => f.path === location.pathname);
      if (!(isNil(currentRoute) || isEmpty(currentRoute))) {
        const { search } = location;
        const screenValues = getScreenVals(search);
        title = getTitleInfo(screenValues, currentRoute, title);
      }
    }
    return title;
  }, [getTitleInfo, location]);
  useEffect(() => {
    document.title = getTitle();
  }, [getTitle]);
  return null;
};

export default DocTitle;
